__turbopack_context__.v({
  "banner": "AddToCartErrorBanner-module-scss-module__AZ0WUG__banner",
});
